import { USER_ROLE } from "../types/UserRole";
export function getQueryParams() {
    let queryString = '';
    if (window.location.hash.includes('?')) {
        queryString = window.location.hash.split('?')[1];
    }
    else if (window.location.search.includes('?')) {
        queryString = window.location.search.substring(1);
    }
    const params = new URLSearchParams(queryString);
    const paramsObj = {};
    params.forEach((value, key) => {
        paramsObj[key] = value;
    });
    console.log('[getQueryParams] params:', paramsObj);
    const pinRaw = params.get('pin');
    const pin = pinRaw ? Number(pinRaw) : undefined;
    if (pinRaw && isNaN(pin)) {
        console.warn(`[getQueryParams] invalid pin: ${pinRaw}`);
    }
    const roleRaw = params.get('role');
    let role = USER_ROLE.CLIENT;
    if (roleRaw && Object.values(USER_ROLE).includes(roleRaw)) {
        role = roleRaw;
    }
    return { pin, role };
}
